/* eslint-disable no-unused-vars */

import React, { useEffect } from 'react'


const TriggerPointDetails = () => {
  
  
  return (
    <div>
        <h1>Trigger Point Details</h1>
    </div>
  )
}

export default TriggerPointDetails